import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from '../../../../components/BobTableContextMenu.module.css';

const EquipmentContextMenu = ({
    dataItem,
    history,
    setCoreEquipment,
    setDeleteEquipmentModalOpen,
    setSelectedEquipment,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditEquipment = equipment => {
        const path = '/v2/dashboard/core/entities/manage';

        const queryValues = queryString.parse(history.location.search);
        queryValues.entityType = 'equipment';
        queryValues.entityId = equipment.id;

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
        setCoreEquipment(equipment);
    };

    const handleDeleteEquipment = equipment => {
        setSelectedEquipment(equipment);
        setDeleteEquipmentModalOpen(true);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    onClick={() => handleEditEquipment(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        edit
                    </span>
                    Edit
                </MenuItem>
                <MenuItem
                    onClick={() => handleDeleteEquipment(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        do_not_disturb_on
                    </span>
                    Deactivate
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default withRouter(EquipmentContextMenu);
